import api from './api';

export const projectService = {
    projectList: async () => {
        const response = await api.get('projects');
        return response.data;
    }
};
